export default __webpack_public_path__ + "static/media/proam.144ca8ee.png";